import * as React from 'react';

import icon1 from './assets/icon_1.png';
import icon2 from './assets/icon_2.svg';
import icon3 from './assets/icon_3.svg';

export interface IAdvantagesItemProps {
  iconUrl: string;
  title: React.ReactNode;
  description: string;
  withAction?: boolean;
  onClick?: () => void;
}

export const ADVANTAGES_CONTENT: IAdvantagesItemProps[] = [
  {
    iconUrl: icon1,
    title: <>Узнайте цену своего дома</>,
    description:
      'Оцениваем квартиру и показываем, как её цена меняется — а ещё составляем подборки недвижимости с учётом ваших пожеланий и возможностей',
  },
  {
    iconUrl: icon2,
    title: (
      <>
        Распоряжайтесь
        <br />
        квартирой с умом
      </>
    ),
    description:
      'Показываем потенциальную стоимость аренды вашей квартиры и рассказываем, как и сколько можно на ней заработать',
  },
  {
    iconUrl: icon3,
    title: (
      <>
        Станьте экспертом <br />в недвижимости
      </>
    ),
    description:
      'Помогаем разобраться в недвижимости с помощью гайдов и рассказываем полезное о жилье в журнале, пишем главное о доме и инфраструктуре. ',
  },
];
